export const isApplicationSource = (testValue: string): testValue is ApplicationSource =>
  Object.keys(SOURCE_TYPE_INFO).indexOf(testValue) !== -1;

export const getSourceTypeInfo = (sourceType: string) => {
  let sourceTypeInfo;
  if (isApplicationSource(sourceType)) {
    sourceTypeInfo = SOURCE_TYPE_INFO[sourceType];
  } else {
    sourceTypeInfo = {
      name: 'Unknown Source',
      isPassive: false,
      isTargetedAdvertising: false,
    };
  }
  return sourceTypeInfo;
};

export const SOURCE_TYPES = Object.freeze({
  FACEBOOK_AD_SET: 'facebook',
  FACEBOOK_JOB_POST: 'facebookjobpost',
  INDEED: 'indeed',
  REFERRAL: 'referral',
  DEMO: 'demo',
  MANUAL: 'manual',
  CRAIGSLIST: 'craigslist',
  QR_CODE: 'qrcode',
  ZIPRECRUITER_STANDARD_SPONSORSHIP: 'ziprecruiter_standard_sponsorship',
  ZIPRECRUITER_PREMIUM_SPONSORSHIP: 'ziprecruiter_premium_sponsorship',
  ZIPRECRUITER_PRO_SPONSORSHIP: 'ziprecruiter_pro_sponsorship',
});

export const ZIPRECRUITER_SOURCE_TYPES = [
  SOURCE_TYPES.ZIPRECRUITER_STANDARD_SPONSORSHIP,
  SOURCE_TYPES.ZIPRECRUITER_PREMIUM_SPONSORSHIP,
  SOURCE_TYPES.ZIPRECRUITER_PRO_SPONSORSHIP,
] as const;

export type SourceTypeValue = ValueOf<typeof SOURCE_TYPES>;

export type ZiprecruiterSourceType = (typeof ZIPRECRUITER_SOURCE_TYPES)[number];

export const isZiprecruiterSourceType = (
  sourceType: SourceTypeValue,
): sourceType is ZiprecruiterSourceType =>
  ZIPRECRUITER_SOURCE_TYPES.includes(sourceType as ZiprecruiterSourceType);

export const SOURCE_TYPE_INFO: Record<ApplicationSource, ApplicationSourceInfo> = Object.freeze({
  appcast: {
    name: 'AppCast',
    isPassive: true,
    isTargetedAdvertising: true,
  },
  demo: {
    name: 'Demo',
    isPassive: true,
    isTargetedAdvertising: true,
  },
  careers_page: {
    name: 'Careers Page',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  craigslist: {
    name: 'Craigslist Ad',
    isPassive: false,
    isTargetedAdvertising: true,
  },
  facebook: {
    name: 'Social Media Ad',
    isPassive: true,
    isTargetedAdvertising: true,
  },
  facebookjobpost: {
    name: 'Facebook Jobs',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  glassdoor: {
    name: 'Glassdoor',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  googledisplayad: {
    name: 'Google Display Ad',
    isPassive: true,
    isTargetedAdvertising: true,
  },
  google_jobs_apply: {
    name: 'Google Search',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  indeed: {
    name: 'Indeed',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  jobisjob: {
    name: 'JobIsJob',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  jooble: {
    name: 'Jooble',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  jora: {
    name: 'Jora',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  qrcode: {
    name: 'QR Code',
    isPassive: true,
    isTargetedAdvertising: false,
  },
  recruitics: {
    name: 'Recruitics',
    isPassive: true,
    isTargetedAdvertising: true,
  },
  redditads: {
    name: 'Reddit Ads',
    isPassive: true,
    isTargetedAdvertising: true,
  },
  redditjobs: {
    name: 'Reddit Jobs',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  referral: {
    name: 'Employee Referral',
    isPassive: true,
    isTargetedAdvertising: false,
  },
  trovit: {
    name: 'Trovit',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  twitter: {
    name: 'Twitter Ad',
    isPassive: true,
    isTargetedAdvertising: true,
  },
  website: {
    name: 'Company Website',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  ziprecruiter: {
    name: 'ZipRecruiter',
    isPassive: false,
    isTargetedAdvertising: false,
  },
  manual: {
    name: 'Manually Entered',
    isPassive: false,
    isTargetedAdvertising: false,
  },
});
